// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#6F7881"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.39765 2.88171C9.58972 2.49259 9.68576 2.29804 9.81613 2.23588C9.92956 2.18179 10.0613 2.18179 10.1748 2.23588C10.3052 2.29804 10.4012 2.49259 10.5933 2.88171L12.4155 6.57335C12.4722 6.68823 12.5005 6.74566 12.542 6.79026C12.5787 6.82975 12.6227 6.86174 12.6715 6.88446C12.7267 6.91013 12.7901 6.9194 12.9169 6.93792L16.9929 7.5337C17.4222 7.59644 17.6368 7.62781 17.7361 7.73264C17.8225 7.82386 17.8631 7.94919 17.8467 8.07376C17.8278 8.21693 17.6724 8.36826 17.3617 8.67093L14.4133 11.5426C14.3214 11.6321 14.2755 11.6769 14.2458 11.7302C14.2195 11.7773 14.2027 11.8291 14.1962 11.8827C14.1889 11.9432 14.1997 12.0064 14.2214 12.1329L14.9171 16.189C14.9904 16.6169 15.0271 16.8308 14.9582 16.9577C14.8982 17.0681 14.7916 17.1456 14.668 17.1685C14.526 17.1948 14.3339 17.0938 13.9497 16.8918L10.3058 14.9755C10.1922 14.9158 10.1355 14.8859 10.0756 14.8742C10.0227 14.8638 9.96822 14.8638 9.91527 14.8742C9.85546 14.8859 9.79869 14.9158 9.68516 14.9755L6.04121 16.8918C5.65704 17.0938 5.46495 17.1948 5.32292 17.1685C5.19934 17.1456 5.09271 17.0681 5.03272 16.9577C4.96378 16.8308 5.00046 16.6169 5.07384 16.189L5.76951 12.1329C5.7912 12.0064 5.80205 11.9432 5.79471 11.8827C5.78821 11.8291 5.77137 11.7773 5.74511 11.7302C5.71546 11.6769 5.66951 11.6321 5.5776 11.5426L2.62924 8.67093C2.3185 8.36826 2.16312 8.21693 2.14421 8.07376C2.12776 7.94919 2.1684 7.82386 2.25482 7.73264C2.35414 7.62781 2.56875 7.59644 2.99798 7.5337L7.07403 6.93792C7.2008 6.9194 7.26418 6.91013 7.31937 6.88446C7.36825 6.86174 7.41224 6.82975 7.44893 6.79026C7.49036 6.74566 7.51872 6.68823 7.57542 6.57335L9.39765 2.88171Z"
    />
  </svg>
);
const IconStar = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconStar;
